// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1dW2i","buttons":"Footer_buttons__3Jpse"};